import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, RadioGroup, FormControlLabel, Radio, Button } from '@material-ui/core';
import { timeFormat2 } from '../../../../common/utils';
import { ADD, CLIENT, EDIT, SPOUSE, VIEW } from '../../../../common/common';
import EditPanel from './Panel/EditPanel';

const Root = styled(Box)({
    width: '100%',
    padding: '0 10px',
    '& .panel-wapper-input': {
        width: '100%',
        marginTop: '10px',
        padding: '0 10px',
        minHeight: '200px',
        border: '1px dashed #EAE8EB',
        backgroundColor: '#FAFAFA',
        '& .text-wapper': {
            width: '50%',
            paddingRight: '15px',
            '& .text-field': {
                width: '100%',
                // backgroundColor: '#FFFFFF',
            },
        },
        '& .text-title': {
            marginTop: '10px',
            fontSize: '14px',
            color: '#9B9B9B',
        },
        '& .tool-view': {
            width: '100%',
            padding: '10px 0',
        },
    },
    '& .textWapper': {
        width: '50%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .dotted-line': {
        width: '100%',
        margin: '10px 0',
        borderBottom: '1px dashed #EAE8EB',
    },
    '& .itemWapper': {
        width: '100%',
        paddingBottom: '10px',
        borderBottom: '1px dashed #EAE8EB',
    },
    '& .panel': {
        width: '100%',
        paddingBottom: '10px',
        borderBottom: '1px dashed #EAE8EB',
    },
})

class Input1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataInfo: {
                "P.F.Name": "",
                "P.L.Name": "",
                "P.DOB": new Date(),
                "P.SSN.L4": "",
                "P.H.Pho": "",
                "P.W.Pho": "",
                "P.Em": "",
                "P.SEX": "",
                "P.F.L.N.I.": "",
                "P.H.Addr.": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
                "S.F.Name": "",
                "S.L.Name": "",
                "S.DOB": new Date(),
                "S.SSN.L4": "",
                "S.H.Pho": "",
                "S.W.Pho": "",
                "S.Em": "",
                "S.F.L.N.I.": "",
                "S.H.Addr.": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
                "type": ""
            },
            openPanel: false,
            panelType: "",
            panelId: "",
            isAdd: false
        }
        this.doNext = this.doNext.bind(this);
        this.addInfoData = this.addInfoData.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
        this.handleClosePanel = this.handleClosePanel.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }
    render() {
        const {
            dataInfo,
            openPanel,
            panelType,
            isAdd
        } = this.state;
        const unitView = (key) => {
            console.log(dataInfo,key)
            if (dataInfo[key]["country"] === "CN") {
                return <div className="text-wapper">
                    <div className="text-title">Principal Unit</div>
                    <div>{dataInfo[key]["unit"]}</div>
                </div>
            }
        }
        const clientView = () => {
            if (dataInfo["P.F.Name"]) {
                return <div className="panel-wapper-input v v-r">
                    <div className="flow">
                        <div className="text-wapper">
                            <div className="text-title">Principal/Client Full Legal Name</div>
                            <div>{dataInfo["P.F.Name"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal/Client Last Name</div>
                            <div>{dataInfo["P.L.Name"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal/Client Initial Name</div>
                            <div>{dataInfo["P.F.L.N.I."]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Gender</div>
                            <div>{dataInfo["P.SEX"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Date of Birth</div>
                            <div>{timeFormat2(dataInfo["P.DOB"])}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Last 4 Digits of Principal Social Security Number</div>
                            <div>{dataInfo["P.SSN.L4"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Choose The Country</div>
                            <div>{dataInfo["P.H.Addr."]["country"]}</div>
                        </div>
                        {unitView("P.H.Addr.")}
                        <div className="text-wapper">
                            <div className="text-title">Principal Street</div>
                            <div>{dataInfo["P.H.Addr."]["street"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal City</div>
                            <div>{dataInfo["P.H.Addr."]["city"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal State</div>
                            <div>{dataInfo["P.H.Addr."]["state"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Zip Code</div>
                            <div>{dataInfo["P.H.Addr."]["zipcode"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Home Phone</div>
                            <div>{dataInfo["P.H.Pho"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Work Phone (Optional)</div>
                            <div>{dataInfo["P.W.Pho"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Email (Optional)</div>
                            <div>{dataInfo["P.Em"]}</div>
                        </div>
                    </div>
                    <div>
                        <Button size="small" color="primary" onClick={e => this.handleEdit(e, CLIENT)}>Edit</Button>
                    </div>
                </div>
            } else {
                return <div className="panel-wapper-input c">
                    <div className="c">
                        <Button size="small" color="primary" onClick={e => this.handleAdd(e, CLIENT)}>Click Add Principal/Client Info</Button>
                    </div>
                </div>
            }
        }
        const spouseView = () => {
            if (dataInfo["S.F.Name"]) {
                return <div className="panel-wapper-input v v-r">
                    <div className="flow">
                        <div className="text-wapper">
                            <div className="text-title">Spouse Full Legal Name</div>
                            <div>{dataInfo["S.F.Name"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Last Name</div>
                            <div>{dataInfo["S.L.Name"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Initial Name</div>
                            <div>{dataInfo["S.F.L.N.I."]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Date of Birth</div>
                            <div>{timeFormat2(dataInfo["S.DOB"])}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Last 4 Digits of Spouse Social Security Number</div>
                            <div>{dataInfo["S.SSN.L4"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Choose The Country</div>
                            <div>{dataInfo["S.H.Addr."]["country"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Street</div>
                            <div>{dataInfo["S.H.Addr."]["street"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse City</div>
                            <div>{dataInfo["S.H.Addr."]["city"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse State</div>
                            <div>{dataInfo["S.H.Addr."]["state"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Zip Code</div>
                            <div>{dataInfo["S.H.Addr."]["zipcode"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Home Phone</div>
                            <div>{dataInfo["S.H.Pho"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Work Phone (Optional)</div>
                            <div>{dataInfo["S.W.Pho"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Spouse Email (Optional)</div>
                            <div>{dataInfo["S.Em"]}</div>
                        </div>
                    </div>
                    <div>
                        <Button size="small" color="primary" onClick={e => this.handleEdit(e, SPOUSE)}>Edit</Button>
                    </div>
                </div>
            } else {
                return <div className="panel-wapper-input c">
                    <div className="c">
                        <Button size="small" color="primary" onClick={e => this.handleAdd(e, SPOUSE)}>Click Add Spouse Info</Button>
                    </div>
                </div>
            }
        }
        return (
            <Root>
                {clientView()}
                {spouseView()}
                <EditPanel
                    open={openPanel}
                    isAdd={isAdd}
                    dataINFO={dataInfo}
                    panelType={panelType}
                    onClose={this.handleClosePanel}
                    updateInfoData={this.updateInfoData}
                    addInfoData={this.addInfoData}
                ></EditPanel>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { data } = this.props;
        console.log("input1 data", data)
        if (!data) return;
        this.setState(() => ({
            dataInfo: data
        }))
    }
    handleAdd(e, type) {
        console.log("点击add", type)
        this.setState({
            panelType: type,
            isAdd: true,
            openPanel: true
        })
    }
    handleEdit(e, type) {
        this.setState({
            panelType: type,
            isAdd: false,
            openPanel: true
        })
    }
    handleClosePanel() {
        this.setState({
            openPanel: false
        })
    }
    addInfoData(panelData) {
        console.log("====panelData====", panelData, "==========")
        this.setDataInfo(panelData, () => {
            this.props.setToAllData("INFO", this.state.dataInfo);
        });
    }
    updateInfoData(panelData) {
        console.log("updateinfo", panelData)
        this.setDataInfo(panelData, () => {
            this.props.setToAllData("INFO", this.state.dataInfo, () => {
                this.props.updateInfoToAllData();
            });
        });
    }
    setDataInfo(panelData, callback = null) {
        const { dataInfo } = this.state;
        for (const key in panelData) {
            if (Object.hasOwnProperty.call(panelData, key)) {
                for (const key2 in dataInfo) {
                    if (Object.hasOwnProperty.call(dataInfo, key2)) {
                        if (key === key2) {
                            dataInfo[key2] = panelData[key];
                        }
                    }
                }
            }
        }
        this.setState({
            dataInfo
        }, () => {
            if (callback) callback();
        });
    }
    doNext() {
        const { dataInfo } = this.state;
        let canNext = true;
        for (const key in dataInfo) {
            if (dataInfo.hasOwnProperty(key)) {
                if (key === "P.H.Addr.") {
                    canNext = this.verifyAddrValue(dataInfo[key]);
                    if (canNext) {
                        continue;
                    }
                } else if (key === "S.Em" || key === "P.Em" || key === "P.W.Pho" || key === "S.W.Pho") {
                    continue;
                }
                if (dataInfo[key] === "" || canNext === false) {
                    return false;
                }
            }
        }
        return true;
    }
    verifyAddrValue(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key === "unit" && obj[key] === "") {
                    if (obj["country"] === "US") {
                        continue;
                    }
                }
                if (key === "phone") {
                    continue;
                }
                if (obj[key] === "") {
                    return false;
                }
            }
        }
        return true;
    }
    getData() {
        return this.state.dataInfo;
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
}

export default Input1;